export { default } from './LyricItem';
